module.exports = __webpack_public_path__ + "img/2023_jeep-gladiator-01.4f075773.jpg";